import React, { useContext } from 'react'
import Popup from '@Components/Popups/Popup'
import UserActionPopup from '@Components/Popups/UserActionPopup'
import { UserMaintenanceActions } from '@Components/UserRowComponent/user-maintenance-actions'
import { UserInfo } from '@Entities/user/user'
import { observer } from 'mobx-react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import { deleteRightsholderUser } from '@App/api/routes/rightsholder/rightsholderUser'

interface UserRowPopupProps {
    onCloseConfirmPopup: () => void
    actionType?: UserMaintenanceActions
    userData: UserInfo
    onReloadData?(): void
}

const UserRowPopup = (props: UserRowPopupProps) => {
    const { preloaderStore, rightsholderUserStore, popupStore, userStore, rightsholderStore } =
        useContext<RootStore>(StoresContext)

    const { onCloseConfirmPopup, actionType, userData, onReloadData } = props

    const onResentInvite = async () => {
        const { firstName, lastName, email, groups } = userData

        try {
            const formData: Partial<UserInfo> = { firstName, lastName, email, groups }

            preloaderStore.openTransparentPreloader(true)
            await rightsholderUserStore.inviteRightsholderUser(formData)
            popupStore.setAlertData(`Invite was resent`, false)
        } catch (error) {
            popupStore.setAlertFromError(error)
        }
        onCloseConfirmPopup()
        preloaderStore.openTransparentPreloader(false)
    }

    const onRemoveUser = async () => {
        const currentRightsholderId = rightsholderStore.currentRightsholderId
        const { exposedId, firstName, lastName } = userData

        if (exposedId) {
            try {
                preloaderStore.openTransparentPreloader(true)
                await deleteRightsholderUser(currentRightsholderId, exposedId)
                onReloadData && (await onReloadData())
                popupStore.setAlertData(`User ${firstName + ' ' + lastName} was removed`, false)
            } catch (error) {
                popupStore.setAlertFromError(error)
            }
            onCloseConfirmPopup()
            preloaderStore.openTransparentPreloader(false)
        }
    }

    const isInternal = userStore.isInternal

    return (
        <Popup onClose={onCloseConfirmPopup}>
            <div className="user-action-popup-content">
                {actionType === UserMaintenanceActions.resentInvite && (
                    <UserActionPopup
                        title="Resend Invite?"
                        user={userData}
                        onCancel={onCloseConfirmPopup}
                        onConfirm={onResentInvite}
                    />
                )}
                {actionType === UserMaintenanceActions.removeUser && (
                    <UserActionPopup
                        title="Remove User?"
                        user={userData}
                        onCancel={onCloseConfirmPopup}
                        onConfirm={onRemoveUser}
                        disabled={isInternal}
                    />
                )}
            </div>
        </Popup>
    )
}

export default observer(UserRowPopup)
